const stateKeys = {
  plans: 'plans'
}

export const actions = {
  clearSettings() {
    for (let ix = 0; ix < stateKeys.length; ix++) {
      this.$storage.removeUniversal(stateKeys[ix])
    }
  },
  setPlans(_, plans) {
    this.$storage.setUniversal(stateKeys.plans, plans)
  },
  getPlans() {
    return this.$storage.getUniversal(stateKeys.plans)
  },
  async getData({ dispatch }, { format, interval }) {
    const data = await this.$apiAaltra.home(format._format, interval._period)

    if (!data) {
      return null
    }

    const history = await dispatch(
      'energy/history/map',
      { data: data.history, format, interval },
      {
        root: true
      }
    )

    const historyChartDataEmpty = await dispatch(
      'checkIfDatasetsDataAreEmpty',
      history ? history.barChartData : null
    )

    const forecastChartData = await dispatch(
      'energy/forecast/mapToChartData',
      {
        timestamps: data.forecast.timestamps,
        data: data.forecast,
        format,
        interval
      },
      { root: true }
    )

    const forecastChartDataEmpty = await dispatch(
      'checkIfDatasetsDataAreEmpty',
      forecastChartData
    )

    const alerts = await dispatch(
      'energy/alerts/mapManyToAlertList',
      data.alerts,
      { root: true }
    )
    const liveData = await dispatch('mapLiveData', {
      current: data.current,
      format
    })

    const plansData = await dispatch('formatPlansData', data.plans)
    await dispatch('setPlans', plansData)

    return {
      ...liveData,
      plans: plansData,
      history: {
        ...history,
        empty: historyChartDataEmpty
      },
      budget: {
        fluctuation: this.$statusFunctionality(data.budget.percentile),
        legend: [
          this.$statusFunctionality(data.budget.percentile).layout.color
        ],
        actual: data.budget.actual,
        expected: data.budget.expected,
        progressbar: {
          max: 1,
          value: this.$getPercentage(data.budget.actual, data.budget.expected),
          indicator: data.budget.monthFraction * 100,
          style: this.$statusFunctionality(data.budget.percentile).layout.color
        },
        unit:
          format._format === 'energy'
            ? this.app.i18n.t('kwh')
            : this.$currency.get()
      },
      forecast: {
        empty: forecastChartDataEmpty,
        colorLegend: [
          this.$chartLegendColor(
            `forecasted-${format.text}`.replace('-grid', '')
          )
        ],
        chartData: forecastChartData,
        percentile: data.forecast.percentile,
        savings: data.forecast.savings,
        fluctuation: data.forecast.percentile
          ? this.$statusFunctionality(data.forecast.percentile)
          : null,
        forecastedTotal: this.$formatEnergy(data.forecast.forecasted.total || 0)
      },
      alerts
    }
  },

  async getLiveData({ dispatch }, format) {
    const data = await this.$apiAaltra.liveData()
    if (data) {
      const mappedLiveData = await dispatch('mapLiveData', {
        current: data.current,
        format
      })
      return {
        plans: data.plans,
        ...mappedLiveData
      }
    }
    return null
  },

  formatPlansData(_, data) {
    const plansData = { ...data }
    // Temporary
    // const plansData = {
    //   budget: null,
    //   // tariff: null
    //   tariff: {
    //     error: false,
    //     warning: true,
    //     end: 1622115721 // 1622115721
    //   },
    //   pvOptimisationStatus: "inactive",
    //   budgetControlStatus: "active"
    // }

    const showBudgetRelatedData = this.$storage.getUniversal(
      'showBudgetRelatedData'
    )

    let tariffData
    if (plansData.tariff && plansData.tariff.end) {
      tariffData = this.$calculateDifferenceBetweenEpochToTimeUnit(
        plansData.tariff.end
      )
    }

    if (
      (tariffData && plansData.tariff.end && plansData.tariff.error) ||
      (tariffData && plansData.tariff.end && plansData.tariff.warning)
    ) {
      const tariffMessageType = plansData.tariff.error
        ? 'error'
        : plansData.tariff.warning
        ? 'reminder'
        : null
      let tariffMessage
      switch (tariffMessageType) {
        case 'error':
          tariffMessage = this.app.i18n.t('tariffUpdateIsOverdue', [
            this.app.i18n.tc(
              'days',
              tariffData.time,
              isNaN(tariffData.time)
                ? [this.app.i18n.t('undefined')]
                : [tariffData.time]
            )
          ])
          break
        default:
          tariffMessage = this.$formatEpochToShortDate(plansData.tariff.end)
            ? this.app.i18n.t('updateTariffBefore', [
                this.$formatEpochToShortDate(plansData.tariff.end)
              ])
            : this.app.i18n.t('updateTariff')
          break
      }
      plansData.tariff.message = {
        type: tariffMessageType,
        text: tariffMessage
      }
    } else {
      let placeholderMessageType
      if (!plansData.tariff || !plansData.budget) {
        if (!plansData.tariff && plansData.budget) {
          placeholderMessageType = 'tariffsetup'
        } else if (
          plansData.tariff &&
          !plansData.budget &&
          showBudgetRelatedData
        ) {
          placeholderMessageType = 'budgetsetup'
        } else if (
          !plansData.tariff &&
          !plansData.budget &&
          showBudgetRelatedData
        ) {
          placeholderMessageType = 'energysetup'
        }
        plansData.placeholder = this.$panelPlaceholder(placeholderMessageType)
      }
    }
    return plansData
  },
  async mapLiveData({ dispatch }, { current, format }) {
    const applianceChartData = await dispatch(
      'energy/appliance/mapManyToChartData',
      { data: current.appliances.items, format },
      {
        root: true
      }
    )

    const applianceListData = await dispatch(
      'energy/appliance/mapManyToListData',
      { data: current.appliances.items, format, mapForHome: true },
      {
        root: true
      }
    )

    return {
      current,
      appliances: {
        count: current.appliances.count,
        listData: applianceListData.regular,
        chartData: applianceChartData,
        alwaysOn: applianceListData.alwaysOn
      }
    }
  },
  checkIfDatasetsDataAreEmpty(_, chartData) {
    if (!chartData) {
      return true
    }
    let dataEmpty = false
    if (chartData && chartData.datasets && chartData.datasets.length > 0) {
      let emptyDataset = 0
      chartData.datasets.forEach((dataset) => {
        let empty = 0
        dataset.data.forEach((d) => {
          if (d === null || d === undefined) {
            empty++
          }
        })
        if (empty === dataset.data.length) {
          emptyDataset++
        }
      })
      if (emptyDataset === chartData.datasets.length) {
        dataEmpty = true
      }
    } else {
      return true
    }
    return dataEmpty
  }
}
